import { createContext, useReducer } from "react";
import axios from "../utils/axios";
import { MapUserConstants } from "../constants/index";

const initialState = {
  isSubmitting: false,
  isLoading: false,
  mapUser: null,
  mapUsers: [],
  franchiseUsers: {}, // Cache for users per franchise
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
};

const MapUserContext = createContext({
  ...initialState,
  addMapUser: () => {},
  getMappingByUserId: () => {},
  getAllMapUsers: () => {},
});

const MapUserReducer = (state, action) => {
  switch (action.type) {
    case MapUserConstants.FETCH_MAP_USER_REQUEST:
      return { ...state, isLoading: true };
    case MapUserConstants.FETCH_MAP_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        mapUsers: action.payload.data,
        paging: action.payload.paging,
      };
    case MapUserConstants.SAVE_MAP_USER_REQUEST:
      return { ...state, isSubmitting: true };
    case MapUserConstants.SAVE_MAP_USER_SUCCESS:
      return { ...state, isSubmitting: false };
    case MapUserConstants.GET_MAP_USER_REQUEST:
      return { ...state, isLoading: true, mapUser: null };
    case MapUserConstants.GET_MAP_USER_SUCCESS:
      return { ...state, isLoading: false, mapUser: action.payload };
    case MapUserConstants.GET_MAP_USER_FAILURE:
      return { ...state, isLoading: false };
    case "SET_FRANCHISE_USERS":
      return {
        ...state,
        franchiseUsers: {
          ...state.franchiseUsers,
          [action.payload.fId]: action.payload.users,
        },
      };
    default:
      return state;
  }
};

function MapUserProvider({ children }) {
  const [state, dispatch] = useReducer(MapUserReducer, initialState);

  const addMapUser = async (payload) => {
    dispatch({ type: MapUserConstants.SAVE_MAP_USER_REQUEST });
    try {
      const response = await axios.post("/cpanel/map-user/add", payload);
      dispatch({ type: MapUserConstants.SAVE_MAP_USER_SUCCESS });
      return response.data;
    } catch (error) {
      console.error(error);
      dispatch({ type: MapUserConstants.SAVE_MAP_USER_SUCCESS });
      throw error;
    }
  };

  const updateMapUser = async (payload) => {
    dispatch({ type: MapUserConstants.SAVE_MAP_USER_REQUEST });
    try {
      const response = await axios.put("/cpanel/map-user/update", payload);
      dispatch({ type: MapUserConstants.SAVE_MAP_USER_SUCCESS });
      return response.data;
    } catch (error) {
      console.error(error);
      dispatch({ type: MapUserConstants.SAVE_MAP_USER_SUCCESS });
      throw error;
    }
  };

  const getMappingByUserId = async (userId) => {
    dispatch({ type: MapUserConstants.GET_MAP_USER_REQUEST });
    try {
      const response = await axios.get(`/cpanel/map-user/${userId}`);
      dispatch({ type: MapUserConstants.GET_MAP_USER_SUCCESS, payload: response.data });
      return response.data;
    } catch (error) {
      console.error(error);
      dispatch({ type: MapUserConstants.GET_MAP_USER_FAILURE });
    }
  };

  const getAllMapUsers = async (payload) => {
    dispatch({ type: MapUserConstants.FETCH_MAP_USER_REQUEST });
    try {
      const response = await axios.post("/cpanel/map-user/list", payload);
      dispatch({ type: MapUserConstants.FETCH_MAP_USER_SUCCESS, payload: response.data });
    } catch (error) {
      console.error(error);
    }
  };

  const setFranchiseUsers = (fId, users) => {
    dispatch({ type: "SET_FRANCHISE_USERS", payload: { fId, users } });
  };

  return (
    <MapUserContext.Provider
      value={{
        ...state,
        addMapUser,
        updateMapUser,
        getMappingByUserId,
        getAllMapUsers,
        setFranchiseUsers,
      }}
    >
      {children}
    </MapUserContext.Provider>
  );
}

export { MapUserContext, MapUserProvider };
